<template>
    <div>
        <div style="padding-top: 32px;"></div>
        <b-card v-if="fetchedFolder != null && fetchedPictures != null" v-bind:header="'Galleri: ' + fetchedFolder.path" class="subfolder-list">
            <div v-if="!mobileLayout && fetchedFolder.effectivePrivilegeAddFiles" style="float:right;" class="upload-container">
                <!-- Drag and drop area -->
                <div
                  class="drop-zone"
                  @dragover.prevent="onDragOver"
                  @dragleave.prevent="onDragLeave"
                  @drop.prevent="onDrop"
                  :class="{ 'drag-over': isDragging }"
                >
                  <p>Drag and drop files or folders here</p>
                  <p v-if="filesToBeUploaded.length">{{ filesToBeUploaded.length }} file(s) ready for upload</p>
                </div>

                <b-button style="height: 25px; padding-top: 0; margin-right: 5px" @click="uploadFiles(fetchedFolder.path)" :disabled="!filesToBeUploaded.length">Upload</b-button>
                <p v-if="message && uploadFinished > new Date()">{{ message }}</p>
                <progress v-if="uploadProgress > 0" :value="uploadProgress" max="100"></progress>
            </div>
            <div  style="display: flex; flex-wrap: wrap;">
                <div v-for="myfolder in fetchedFolder.folders" v-bind:key="myfolder.displayName">
                    <b-list-group-item v-if="fetchedFolder.path === '/'"
                            :href="`#/gallery/#${myfolder.displayName}`">
                        {{ myfolder.displayName }}
                    </b-list-group-item>
                    <b-list-group-item v-if="fetchedFolder.path !== '/'"
                            :href="`#/gallery/#${fetchedFolder.path + myfolder.displayName}`">
                        {{ myfolder.displayName }}
                    </b-list-group-item>
                </div>
                <b-button v-if="!mobileLayout && fetchedFolder.effectivePrivilegeAddFolders && fetchedPictures != null && fetchedPictures.length > 0" style="height: 25px; padding-top: 0; margin-right: 5px" @click="createFolder(fetchedFolder.path)">Create sub gallery</b-button>
            </div>
            <p class="card-text mt-2">{{fetchedFolder.text}}</p>
        </b-card>
        

        <div v-if="fetchedFolder == null || fetchedPictures == null" class="d-flex justify-content-center mb-3">
            <b-spinner>Loading</b-spinner>
        </div>

        <!-- The picture gallery. Using vue-picture-swipe -->
        <!--<div v-if="fetchedVideos != null" style="background-color: yellow; padding: 0px">
            <vue-picture-swipe v-bind:class="computedLayout_staffans_picture_swipe" id="picture-swipe" :items="fetchedPictures"></vue-picture-swipe>
        </div>-->

        <div v-if="totalNoPictures > picturesPerPage" class="fixed_pagination">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalNoPictures"
              :per-page="picturesPerPage"
              limit="10"
              align="center"
              first-number
              last-number
          ></b-pagination>
        </div>

        

        <!-- The picture gallery -->
        <div class="mycards">

          <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="pswp__bg"></div>
            <div class="pswp__scroll-wrap">
              <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
              </div>
              <div class="pswp__ui pswp__ui--hidden">

                <div class="pswp__top-bar">
                    <div class="pswp__counter"></div>
                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                    <button class="pswp__button pswp__button--rotate pswp__button--rotate--left" title="Rotate left" v-if="options.rotationOn" @click="rotate(-90)"></button>
                    <button class="pswp__button pswp__button--rotate pswp__button--rotate--right" title="Rotate right" v-if="options.rotationOn" @click="rotate(90)"></button>

                    <button class="pswp__button pswp__button--share" title="Share"></button>
                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                            <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                    <div class="pswp__share-tooltip"></div>
                </div>
                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" @click='resetAngle'>
                </button>
                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)" @click='resetAngle'>
                </button>
                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>
                </div>
            </div>
          </div>

          

            <div v-for="(item, index) in fetchedPictures" :src="item.src"
                    v-bind:key="index" class="mycard">
              <figure v-if="item.typ == 'p'" class="my-gallery-item"
                      v-bind:class="computedLayoutElementPicture"
                      v-show="index === 0 || !singleThumbnail">
                <a :href="item.src" itemprop="contentUrl" :data-size="'' + item.w + 'x' + item.h" :title="item.title">
                    <img v-if="item.thumbnail == null" v-bind:class="computedPictureLayout" src="../assets/default_thumbnail.jpg" :alt="item.alt" itemprop="thumbnail"/>
                    <img v-if="item.thumbnail != null" v-bind:class="computedPictureLayout" :src="item.thumbnail" :alt="item.alt" itemprop="thumbnail"/>
                </a>
              </figure>

              <video v-if="item.typ == 'v' && item.thumbnail != null" v-bind:class="computedVideoLayout" controls preload="none" v-bind:poster="item.thumbnail">
                  <source v-bind:src="serverUrl + '/video-streamer-server/download/' + item.url + '?X-JWT-Assertion=' + loadedToken + '&One-Time-Token=' + loadedOtt" type="video/mp4">
                  Your browser does not support the video tag.
              </video>
              <video v-if="item.typ == 'v' && item.thumbnail == null" v-bind:class="computedVideoLayout" controls preload="none" poster="../assets/default_poster.jpg">
                  <source v-bind:src="serverUrl + '/video-streamer-server/download/' + item.url + '?X-JWT-Assertion=' + loadedToken + '&One-Time-Token=' + loadedOtt" type="video/mp4">
                  Your browser does not support the video tag.
              </video>

              <!--<div v-if="fetchedFolder.readOnly" class="caption">
                <div class="caption" style="float: right">
                  <div style="font-size: 50%; -webkit-text-fill-color: #eee; text-align: right">
                    {{item.displayName}}&nbsp;<b-icon icon="camera" @click="showModal(index, item)" style="cursor: pointer;"></b-icon>
                  </div>
                </div>
                <span>{{ item.title }}</span>

              </div>

              <div v-if="!fetchedFolder.readOnly" class="caption">
                <b-icon icon="pencil" @click="showModal(index, item)" style="cursor: pointer;"></b-icon>&nbsp;
                <div  style="float: right">
                  <div style="font-size: 50%; -webkit-text-fill-color: #eee; text-align: right">
                    {{item.displayName}}
                  </div>
                </div>
                <span v-b-popover.hover.bottomleft="item.title">{{ item.title }}</span>

                
              </div>-->

              <div class="caption">
                <b-icon v-if="fetchedFolder != null && !fetchedFolder.readOnly" icon="pencil" @click="showModal(index, item)" style="cursor: pointer; margin-right:8px"></b-icon>
                <div  style="float: right">
                  <div style="float: left; font-size: 50%; -webkit-text-fill-color: #eee; text-align: right">
                    {{item.displayName}}
                  </div>
                  <b-icon v-if="item.typ == 'p'" icon="camera" @click="showExifModal(index, item)" style="float: right; cursor: pointer; margin-left:8px"></b-icon>
                  <b-icon v-if="item.typ == 'v'" icon="camera-reels" @click="showExifModal(index, item)" style="float: right; cursor: pointer; margin-left:8px"></b-icon>
                  <b-icon v-if="item.hasPosition" icon="globe" @click="showMapModal(index, item)" style="float: right; cursor: pointer; margin-left:8px"></b-icon>
                </div>
                <span v-if="!mobileLayout" v-b-popover.hover.bottomleft="item.title">{{ item.title }}</span>
                <span v-if="mobileLayout">{{ item.title }}</span>
              </div>

                <b-modal :ref="'modal' + index" :title="item.displayName" @ok="onSubmitCaption">
                  <b-form-textarea
                    id="textarea-caption"
                    v-model="modalTextBuffer"
                    placeholder="Skriv en bildtext"
                  ></b-form-textarea>
                </b-modal>

                <b-modal :ref="'modal-exif' + index" :title="'EXIF för ' + item.displayName" ok-only>
                  <b-form-textarea readonly
                    style="height: 300px"
                    id="textarea-exif"
                    v-model="exifTextBuffer"
                  ></b-form-textarea>
                </b-modal>

                <b-modal :ref="'modal-map' + index" :title="item.displayName" ok-only>
                  <div :id="'map' + index" :ref="'map' + index" style="height: 300px"><b-spinner>Loading Google maps</b-spinner></div>
                </b-modal>

                

            </div>
          </div>

          <b-modal ref="modalCreateFolder" :title="'Create sub gallery'" @ok="onSubmitCreateFolder">
            <b-form-input
              id="textarea-create-folder"
              v-model="createFolderTextBuffer"
              placeholder="Enter a name for the new gallery"
            ></b-form-input>
          </b-modal>
        

        <!-- The video gallery -->
        <!--<div v-if="fetchedVideos != null" class="mycards">
            

            <div v-for="(item, index) in fetchedVideos" v-bind:key="index" border=1 class="mycard">
              
                    <video v-if="item.posterUrl != null" v-bind:class="computedVideoLayout" controls preload="none" v-bind:poster="serverUrl + '/video-streamer-server/download/'  + item.posterUrl + '?X-JWT-Assertion=' + loadedToken">
                        <source v-bind:src="serverUrl + '/video-streamer-server/download/' + item.url + '?X-JWT-Assertion=' + loadedToken" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                    <video v-if="item.posterUrl == null" v-bind:class="computedVideoLayout" controls preload="none" poster="../assets/default_poster.jpg">
                        <source v-bind:src="serverUrl + '/video-streamer-server/download/' + item.url + '?X-JWT-Assertion=' + loadedToken" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>

              <div v-if="mobileLayout" class="caption">
                <div class="caption" style="float: right">
                  <div style="font-size: 50%; -webkit-text-fill-color: #eee; text-align: right"><a v-bind:href="serverUrl + '/video-streamer-server/download/' + item.url" @click.prevent="downloadItem(serverUrl + '/video-streamer-server/download/' + item.url + '?X-JWT-Assertion=' + loadedToken, item.displayName)">{{ item.displayName }} <img width="10" style="margin-bottom: -3px;" src="../assets/download.png"/></a></div>
                </div>
                <span>{{ item.title }}</span>

              </div>

              <div v-if="!mobileLayout" class="caption">
                <b-icon icon="pencil" @click="showModal(index, item)" style="cursor: pointer;"></b-icon>&nbsp;
                <div  style="float: right">
                  <div style="font-size: 50%; -webkit-text-fill-color: #eee; text-align: right">
                    {{item.displayName}}
                  </div>
                </div>
                <span v-b-popover.hover.bottomleft="item.text">{{ item.text }}</span>

                
              </div>
                
            </div>
        </div>-->
    </div>
</template>

<script>
// Import Axios so that we can perform REST calls to the video-streamer-server back-end.
import axios from 'axios';

// Import globalStore so that we get access to global variables defined in main.js
import {globalStore} from '../main.js'

// Import PhotoSwipe
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import gmapsInit from '../gmaps';

    export default {
        name: 'VideoPlayer',
        props: {
            // Component property for receiving an optional one-time-token.
            ott: {
                type: String,
            }
        },
        data() {
            return {
                foldersLoading: "Loading folders", //string = "No folders yet", //this.fetchFolderList("");
                videosLoading: "Loading videos", // string = "No videos yet", //this.fetchVideoList();
                fetchedFolder: null, // = null,
                //fetchedVideos: null, // = null,
                fetchedPictures: null,
                loadedToken: null,
                loadedOtt: null,
                windowWidth: window.innerWidth,
                computedLayout: 'grid-container_mobile',
                computedLayoutElement: 'video33_mobile',
                computedLayoutElementPicture: 'picture33_mobile',
                computedVideoLayout: 'video_mobile',
                computedPictureLayout: 'thumbnail_mobile',
                computedLayout_staffans_picture_swipe: 'staffans_picture_swipe',
                mobileLayout: false,

                // This is the hostname part of the URL to the repo-list-server backend. The back-end normally
                // runs in a JBoss Wildfly somewhere.
                // While developing, it might be desirable to run the back-end on localhost in which case you
                // might get a port collision if both the Wildfly and the webpack-dev-server wants to run on
                // port 8080. But it turns out, the webpack-dev-server will automatically use 8081 if 8080 is
                // in use. So when developing and running everything locally, do as follows:
                // 1. Start the Wildfly with the repo-list-server back-end normally on port 8080.
                // 2. Run the webpack-dev-server normally with "npm run serve" and it will use 8081.
                // 3. Open http://localhost:8081/
                // 
                // The host part of the URL to the back-end has been made configurable via an environment variable:
                //      VUE_APP_BACK_END_HOST_URL
                // An environment variable's value can be obtained through process.env.<environment-variable-name>.
                // For environment variables to work, @vue/cli requires all the variables to be defined in files
                // called ".env" or "env.<mode>" in the root of the project. I.e. the files must begin with ".env"
                // and "<something>.env" will not work. The <mode> part can be either "development" or "production"
                // and specifies in which mode they will be used. Thus, it is possible to provide different values
                // for different run modes.
                // E.g. sample values for this variable in different modes would be:
                // mode development (file .env): VUE_APP_BACK_END_HOST_URL=http://localhost:8080
                // mode production: (file .env.production) VUE_APP_BACK_END_HOST_URL=https://hem.fomalhaut.se
                serverUrl: "<undefined>", //string = "<undefined>";

                // PhotoSwipe variables below.
                options: { escKey: true, },
                singleThumbnail: false,     // If true, only one thumbnail will be visible in the gallery
                pswp: null,                 // Access to the PhotoSwipe element that displays the picture
                angle: 0,
                currentPage: 1,
                picturesPerPage: 50,
                totalNoPictures: 0,
                modalTextBuffer: "",
                exifTextBuffer: "",
                createFolderTextBuffer: "",
                selectedPicture: null,

                // For the upload file functionality
                filesToBeUploaded: [],
                chunkSize: 1024 * 1024, // 1MB per chunk
                uploadProgress: 0,
                message: "",
                uploadFinished: new Date(),
                isDragging: false,

                map: null
            }
        },

        /*
         *  Method that is called right after an instance has been created.
         */
        created() {
            this.newLayout();
            this.fetchData()
        },

        /*mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth
                if(this.windowWidth <= 1050) {
                    this.mobileLayout = true;
                    globalStore.mobileMode = true;
                    this.computedLayout = 'grid-container_mobile';
                    this.computedLayoutElement = 'video33_mobile';
                    this.computedVideoLayout = 'video_mobile';
                } else {
                    this.mobileLayout = false;
                    globalStore.mobileMode = false;
                    this.computedLayout = 'grid-container';
                    this.computedLayoutElement = 'video33';
                    this.computedVideoLayout = 'video';
                }
            }
        },*/

        /*
            The updated method is called right after the component html template has been
            completely rendered. This makes it possible to perform processing that relies
            on DOM structures.
        */
    updated() {
      let that = this;
      let initPhotoSwipeFromDOM = function (gallerySelector) {
        // parse slide data (url, title, size ...) from DOM elements
        // (children of gallerySelector)
        let parseThumbnailElements = function (el) {
          let thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;
          console.log("thumbElements:" + thumbElements + ", numNodes: " + numNodes);

          for(let i = 0; i < numNodes; i++) {
            console.log("thumbElement #" + i + ": " + thumbElements[i] + ". NodeType: " + thumbElements[i].nodeType);
          }

          // Staffans hack:
          // Hardcoding i = 0 means that we assume the <figure> tag (containing the thumbnail to be PhotoSwiped)
          // is the _first_ tag for each picture in the gallery. All trailing html for a picture is ignored by
          // PhotoSwipe, which is what we want in this case.
          // Staffan removed this loop: for (let i = 0; i < numNodes; i++) {

            let i = 0;
            figureEl = thumbElements[i]; // <figure> element
            // include only element nodes
            if (figureEl.nodeType !== 1) {
              //continue;
              return items;
            }
            linkEl = figureEl.children[0]; // <a> element
            console.log("LinkEl:" + figureEl.children);
            size = linkEl.getAttribute('data-size').split('x');
            // create slide object
            item = {
              src: linkEl.getAttribute('href'),
              w: parseInt(size[0], 10),
              h: parseInt(size[1], 10),
              title: linkEl.getAttribute('title')
            };
            if (figureEl.children.length > 1) {
              // <figcaption> content
              item.title = figureEl.children[1].innerHTML;
            }
            if (linkEl.children.length > 0) {
              // <img> thumbnail element, retrieving thumbnail url
              item.msrc = linkEl.children[0].getAttribute('src');
            }
            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
          //}
          return items;
        };
        // find nearest parent element
        let closest = function closest(el, fn) {
          return el && (fn(el) ? el : closest(el.parentNode, fn));
        };
        // triggers when user clicks on thumbnail
        let onThumbnailsClick = function (e) {
            console.log("Någon klickar på en bild");
          e = e || window.event;
          e.preventDefault ? e.preventDefault() : e.returnValue = false;
          let eTarget = e.target || e.srcElement;
          // find root element of slide
          let clickedListItem = closest(eTarget, function (el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
          });
          if (!clickedListItem) {
            return;
          }
          // find index of clicked item by looping through all child nodes
          // alternatively, you may define index via data- attribute
          let clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;
          for (let i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
              continue;
            }
            if (childNodes[i] === clickedListItem) {
              index = nodeIndex;
              break;
            }
            nodeIndex++;
          }
          if (index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe(index, clickedGallery);
          }
          return false;
        };
        // parse picture index and gallery index from URL (#&pid=1&gid=2)
        let photoswipeParseHash = function () {
          let hash = window.location.hash.substring(1),
            params = {};
          if (hash.length < 5) {
            return params;
          }
          let vars = hash.split('&');
          for (let i = 0; i < vars.length; i++) {
            if (!vars[i]) {
              continue;
            }
            let pair = vars[i].split('=');
            if (pair.length < 2) {
              continue;
            }
            params[pair[0]] = pair[1];
          }
          if (params.gid) {
            params.gid = parseInt(params.gid, 10);
          }
          return params;
        };
        let openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
          console.log("Open PSW for index " + index);
          let pswpElement = galleryElement.parentElement.querySelector('.pswp'),
            gallery,
            options,
            items;
          items = parseThumbnailElements(galleryElement);
          // define options (if needed)
          options = {
            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: function (index) {
              // See Options -> getThumbBoundsFn section of documentation for more info
              let thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();
              return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            }
          };
          // PhotoSwipe opened from URL
          if (fromURL) {
            if (options.galleryPIDs) {
              // parse real index when custom PIDs are used
              // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
              for (let j = 0; j < items.length; j++) {
                if (items[j].pid == index) {
                  options.index = j;
                  break;
                }
              }
            } else {
              // in URL indexes start from 1
              options.index = parseInt(index, 10) - 1;
            }
          } else {
            options.index = parseInt(index, 10);
          }
          // exit if index not found
          if (isNaN(options.index)) {
            return;
          }
          if (disableAnimation) {
            options.showAnimationDuration = 0;
          }
          // Pass data to PhotoSwipe and initialize it
          console.log("Nu skapar vi photoswipe: " + pswpElement);
          gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, Object.assign(options, that.options));
          gallery.listen('gettingData', function(index, item) {
            if (item.w < 1 || item.h < 1) { // unknown size
              let img = new Image();
              img.onload = function() { // will get size after load
                item.w = this.width; // set image width
                item.h = this.height; // set image height
                gallery.invalidateCurrItems(); // reinit Items
                gallery.updateSize(true); // reinit Items
              };
              img.src = item.src; // let's download image
            }
          });
          gallery.init();
          console.log("Nu startar photoswipe");
          that.pswp = gallery;
        };
        // loop through all gallery elements and bind events
        let galleryElements = document.querySelectorAll(gallerySelector);
        for (let i = 0, l = galleryElements.length; i < l; i++) {
          //console.log("Adding pswp-event to picture " + i);
          galleryElements[i].setAttribute('data-pswp-uid', i + 1);
          galleryElements[i].onclick = onThumbnailsClick;
        }
        // Parse URL and open gallery if it contains #&pid=3&gid=1
        let hashData = photoswipeParseHash();
        if (hashData.pid && hashData.gid) {
          openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
        }
        //console.log("1. Nu aer allt pswp inlaest tror jag");
      };
      initPhotoSwipeFromDOM('.my-gallery-item');
      //console.log("2. Nu aer pswp faerdiginitierat tror jag");
    },
        

        watch: {
            // call again the method if the route changes
            '$route': 'fetchData',
            'computedMobileMode': 'newLayout',
            'currentPage': 'pageSelected'
        },

        computed: {
            computedMobileMode: function () {
                // We fetch the value of the global variable "mobileMode" here.
                // We have put it in the "computed" section so that it will be
                // re-calculated on each render.
                return globalStore.mobileMode
            }
        },
        methods: {
            pageSelected() {
                console.log("New page selected: " + this.currentPage);
                this.fetchData();
            },
            newLayout() {
                if(globalStore.mobileMode) {
                    console.log("newLayout anropat i mobile mode");
                    this.mobileLayout = true;
                } else {
                    console.log("newLayout anropat i vanligt läge");
                    this.mobileLayout = false;
                }
                    
                    /*this.computedLayout = 'grid-container_mobile';
                    this.computedLayoutElement = 'video33_mobile';
                    this.computedLayoutElementPicture = 'picture33_mobile';
                    this.computedVideoLayout = 'video_mobile';
                    this.computedPictureLayout = 'thumbnail_mobile';
                    *///this.computedLayout_staffans_picture_swipe = 'staffans_picture_swipe_mobile';
                /*} else {
                    console.log("newLayout anropat i vanligt läge");
                    this.mobileLayout = false;
                    this.computedLayout = 'grid-container';
                    this.computedLayoutElement = 'video33';
                    //this.computedLayoutElementPicture = 'picture33';
                    this.computedVideoLayout = 'video';
                    //this.computedPictureLayout = 'thumbnail';
                    //this.computedLayout_staffans_picture_swipe = 'staffans_picture_swipe';
                }*/
            },

            fetchData() {
                // Display the loading spinner while everything loads.
                //this.fetchedVideos = null;
                this.fetchedPictures = null;

                // Get path to folder to load from the specified URL (this.$route.hash contains
                // everything after the hash '#' in the URL).
                var currentFolderPath = this.$route.hash.substring(1, this.$route.hash.length);
                //alert("Fetching folder: " + folderPath);
                this.fetchFolderList(currentFolderPath);
                this.fetchVideoList(currentFolderPath);
            },

            /*
             *  Function to download the video file, rather than displaying it inline on the page.
             */
            downloadItem(url, fileName) {
                axios.get(url, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/octet-stream' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = fileName
                        link.click()
                        URL.revokeObjectURL(link.href)
                    }).catch(console.error)
            },

            fetchFolderList(folderPath) {
                //alert("Fetching folders from folderPath: " + folderPath);
                if(folderPath == "/") {
                  folderPath = "";
                }

                this.foldersLoading = "Folders loading";
                this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;
                //alert("serverUrl: " + this.serverUrl);
                //axios.get(this.serverUrl + "/video-streamer-server/rest/v2/folders/" + this.currentPath.join("/") + "/" + subFolderName, {

                const queryString = window.location.search;
                console.log(queryString);
                const urlParams = new URLSearchParams(queryString);
                this.loadedOtt = urlParams.get('ott');

                this.$auth.getTokenSilently().then((token) => {
                    this.loadedToken = token;
                    axios.get(this.serverUrl + "/video-streamer-server/rest/v2/folders/" + folderPath + "?One-Time-Token=" + this.loadedOtt, {
                        headers: {
                            //Authorization: `Bearer ${this.jwtToken}`    // send the access token through the 'Authorization' header
                            //'X-JWT-Assertion': '${this.jwtToken}'
                            'X-JWT-Assertion': `${token}`
                        }
                    }).then((response) => {
                        //this.loading = false;
                        //this.fetchedRepos = response.data.repos;
                        //alert("Called rest folders ok:" + response.data.path);
                        //if (subFolderName != "") this.currentPath.push(subFolderName);
                        //this.fetchedSubfolders = response.data.folders;
                        this.fetchedFolder = response.data;
                        //alert("Fetched folders from folderPath: " + this.fetchedFolder.folders);
                        //this.videosLoading = this.fetchVideoList();
                        return "OK"
                    }, (error) => {
                        //this.loading = false;
                        alert(error)
                        return "Error"
                    })
                }, (error) => {
                    axios.get(this.serverUrl + "/video-streamer-server/rest/v2/folders/" + folderPath + "?One-Time-Token=" + this.loadedOtt, {
                    }).then((response) => {
                        this.fetchedFolder = response.data;
                        return "OK"
                    }, (error) => {
                        alert(error)
                        return "Error"
                    })
                    console.log("Attempting to fetch folders via OTT");
                    //console.log("No token could be fetched from Auth0: " + error + ". Redirecting to login prompt");
                    //this.$auth.loginWithRedirect();
                })
                return "Folders not finished yet"
            },

            fetchVideoList(folderPath) {
                if(folderPath == "/") {
                  folderPath = "";
                }

                this.videosLoading = "Videos loading";
                this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;

                const queryString = window.location.search;
                console.log(queryString);
                const urlParams = new URLSearchParams(queryString);
                this.loadedOtt = urlParams.get('ott');

                this.$auth.getTokenSilently().then((token) => {
                    axios.get(this.serverUrl + "/video-streamer-server/rest/v2/videos/" + folderPath + "?offset=" + (this.currentPage - 1) * this.picturesPerPage + "&length=" + this.picturesPerPage + "&One-Time-Token=" + this.loadedOtt, {
                        headers: {
                            //Authorization: `Bearer ${this.jwtToken}`    // send the access token through the 'Authorization' header
                            //'X-JWT-Assertion': '${this.jwtToken}'
                            'X-JWT-Assertion': `${token}`
                        }
                    }).then((response) => {
                        //this.loading = false;
                        //this.fetchedRepos = response.data.repos;
                        //alert("Called rest videos ok:" + response.data.path);
                        //this.fetchedVideos = response.data.videos;

                        this.fetchedPictures = [];
                        this.totalNoPictures = response.data.totalNoPictures;
                        if((this.currentPage - 1) * this.picturesPerPage >= this.totalNoPictures) {
                          this.currentPage = 1;
                        }
                        for(var picture of response.data.pictures) {
                          console.log("Adding item of type: " + picture.type + ", namn=" + picture.displayName);
                          if(picture.type == "p") {
                            //alert("Pictures: " + picture.posterUrl + ": " + JSON.stringify(this.fetchedPictures, null, 4));
                            if(picture.position != null) {
                              console.log("Found picture with position: " + picture.displayName + ", lat: " + picture.position.latitude + ", lgt: " + picture.position.longitude);
                            }
                            this.fetchedPictures.push({
                                typ: "p",
                                src: this.serverUrl + '/video-streamer-server/download/'  + picture.url + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott,
                                url: picture.url,
                                thumbnail: picture.posterUrl? this.serverUrl + '/video-streamer-server/download/'  + picture.posterUrl + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott: null,
                                w: picture.width,
                                h: picture.height,
                                title: picture.text,
                                displayName: picture.displayName,
                                hasPosition: picture.position? true : false,
                                lat: picture.position? picture.position.latitude : null,
                                lgt: picture.position? picture.position.longitude : null,
                            });
                          } else if(picture.type == "v") {
                            console.log("Pushing video with thumbnail: " + picture.posterUrl);
                            this.fetchedPictures.push({
                                typ: "v",
                                src: this.serverUrl + '/video-streamer-server/download/'  + picture.url + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott,
                                url: picture.url,
                                thumbnail: picture.posterUrl? this.serverUrl + '/video-streamer-server/download/'  + picture.posterUrl + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott: null,
                                w: 640,
                                h: 480,
                                title: picture.text,
                                displayName: picture.displayName,
                                hasPosition: picture.position? true : false,
                                lat: picture.position? picture.position.latitude : null,
                                lgt: picture.position? picture.position.longitude : null,
                            })
                          }
                        }

                        /*for(var video of response.data.videos) {
                            //alert("Videos: " + video.posterUrl + ": " + JSON.stringify(this.fetchedVideos, null, 4));
                            this.fetchedPictures.push({
                                typ: "v",
                                src: this.serverUrl + '/video-streamer-server/download/'  + video.url + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott,
                                url: video.url,
                                thumbnail: video.posterUrl? this.serverUrl + '/video-streamer-server/download/'  + video.posterUrl + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott: null,
                                w: 640,
                                h: 480,
                                title: video.text,
                                displayName: video.displayName
                            })
                        }*/

                        return "OK"
                    }, (error) => {
                        //this.loading = false;
                        alert(error)
                        return "Error"
                    })
                }, (error) => {
                    axios.get(this.serverUrl + "/video-streamer-server/rest/v2/videos/" + folderPath + "?offset=" + (this.currentPage - 1) * this.picturesPerPage + "&length=" + this.picturesPerPage + "&One-Time-Token=" + this.loadedOtt, {
                    }).then((response) => {
                        //this.loading = false;
                        //this.fetchedRepos = response.data.repos;
                        //alert("Called rest videos ok:" + response.data.path);
                        //this.fetchedVideos = response.data.videos;

                        this.fetchedPictures = [];
                        this.totalNoPictures = response.data.totalNoPictures;
                        if((this.currentPage - 1) * this.picturesPerPage >= this.totalNoPictures) {
                          this.currentPage = 1;
                        }
                        for(var picture of response.data.pictures) {
                          console.log("Adding item of type: " + picture.type + ", namn=" + picture.displayName);
                          if(picture.type == "p") {
                            //alert("Pictures: " + picture.posterUrl + ": " + JSON.stringify(this.fetchedPictures, null, 4));
                            if(picture.position != null) {
                              console.log("Found picture with position: " + picture.displayName + ", lat: " + picture.position.latitude + ", lgt: " + picture.position.longitude);
                            }
                            this.fetchedPictures.push({
                                typ: "p",
                                src: this.serverUrl + '/video-streamer-server/download/'  + picture.url + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + this.loadedOtt,
                                url: picture.url,
                                thumbnail: picture.posterUrl? this.serverUrl + '/video-streamer-server/download/'  + picture.posterUrl + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + this.loadedOtt: null,
                                w: picture.width,
                                h: picture.height,
                                title: picture.text,
                                displayName: picture.displayName,
                                hasPosition: picture.position? true : false,
                                lat: picture.position? picture.position.latitude : null,
                                lgt: picture.position? picture.position.longitude : null,
                            });
                          } else if(picture.type == "v") {
                            console.log("Pushing video with thumbnail: " + picture.posterUrl);
                            this.fetchedPictures.push({
                                typ: "v",
                                src: this.serverUrl + '/video-streamer-server/download/'  + picture.url + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + this.loadedOtt,
                                url: picture.url,
                                thumbnail: picture.posterUrl? this.serverUrl + '/video-streamer-server/download/'  + picture.posterUrl + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + this.loadedOtt: null,
                                w: 640,
                                h: 480,
                                title: picture.text,
                                displayName: picture.displayName,
                                hasPosition: picture.position? true : false,
                                lat: picture.position? picture.position.latitude : null,
                                lgt: picture.position? picture.position.longitude : null,
                            })
                          }
                        }

                        /*for(var video of response.data.videos) {
                            //alert("Videos: " + video.posterUrl + ": " + JSON.stringify(this.fetchedVideos, null, 4));
                            this.fetchedPictures.push({
                                typ: "v",
                                src: this.serverUrl + '/video-streamer-server/download/'  + video.url + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott,
                                url: video.url,
                                thumbnail: video.posterUrl? this.serverUrl + '/video-streamer-server/download/'  + video.posterUrl + '?X-JWT-Assertion=' + this.loadedToken + "&One-Time-Token=" + localStorage.ott: null,
                                w: 640,
                                h: 480,
                                title: video.text,
                                displayName: video.displayName
                            })
                        }*/

                        return "OK"
                    }, (error) => {
                        //this.loading = false;
                        alert(error)
                        return "Error"
                    })
                    console.log("Attempting to get videos via OTT");
                    //console.log("No token could be fetched from Auth0: " + error + ". Redirecting to login prompt");
                    //this.$auth.loginWithRedirect();
                })
                return "Videos not finished yet"
            },

            /* PhotoSwipe related methods below */
            rotate: function(newAngle) {
                this.angle = this.angle + newAngle
                this.$el.querySelectorAll('.pswp__img').forEach(i => i.style.transform = `rotate(${this.angle}deg)`)
            },
            resetAngle: function() {
                this.angle = 0
                this.$el.querySelectorAll('.pswp__img').forEach(i => i.style.transform = `rotate(${this.angle}deg)`)
            },

            showModal(index, picture) {
                this.selectedPicture = picture;
                this.modalTextBuffer = picture.title; /* Display the caption text in the modal */
                this.$refs['modal' + index][0].show();
            },
            hideModal(index) {
                this.$refs['modal' + index][0].hide();
            },

            showExifModal(index, picture) {
                this.selectedPicture = picture;

                this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;
                this.$auth.getTokenSilently().then((token) => {
                    axios.get(this.serverUrl + "/video-streamer-server/rest/v2/exif/" + this.selectedPicture.url + "?One-Time-Token=" + localStorage.ott, {
                        headers: {
                            'X-JWT-Assertion': `${token}`
                        }
                    }).then((response) => {

                        console.log("Exif: " + response.data);
                        this.exifTextBuffer = response.data.exif;
                        this.$refs['modal-exif' + index][0].show();
                        
                    }, (error) => {
                        //this.loading = false;
                        alert(error)
                        return "Error"
                    })
                }, (error) => {
                    console.log("No token could be fetched from Auth0: " + error + ". Redirecting to login prompt");
                    this.$auth.loginWithRedirect();
                })
                
                //this.modalTextBuffer = picture.title; /* Display the caption text in the modal */
                /*EXIF.getData(picture, function() {
                 vm.exifs = this
                });*/
                
            },
            async showMapModal(index, picture) {
                this.selectedPicture = picture;
                this.$refs['modal-map' + index][0].show();

                // Wait until the Google map init script has been loaded
                const google = await gmapsInit();

                // Show the Google map. Center at location of where picture/video was taken.
                this.map = new google.maps.Map(this.$refs['map' + index][0], {
                      zoom: 12,
                      //center: { lat: -25.344, lng: 131.036 }
                      center: { lat: picture.lat, lng: picture.lgt }
                    });

                // Show the marker, positioned at map center.
                const marker = new google.maps.Marker({
                  position: { lat: picture.lat, lng: picture.lgt },
                  map: this.map,
                });
            },
            onSubmitCaption(event) {
              if(this.modalTextBuffer === null) {
                console.log("Text not changed, null");
                return;
              }
              if(this.selectedPicture.title != null && this.selectedPicture.title.localeCompare(this.modalTextBuffer.trim()) == 0) {
                console.log("Text not changed");
                return;
              }

              console.log("Writing text: " + this.modalTextBuffer.trim() + " for picture " + this.selectedPicture.url);
              this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;
                this.$auth.getTokenSilently().then((token) => {
                    axios.post(this.serverUrl + "/video-streamer-server/rest/v2/caption/" + this.selectedPicture.url, {
                        text: this.modalTextBuffer.trim()
                    },
                    {
                        headers: {
                            //Authorization: `Bearer ${this.jwtToken}`    // send the access token through the 'Authorization' header
                            //'X-JWT-Assertion': '${this.jwtToken}'
                            'X-JWT-Assertion': `${token}`
                        }
                    }).then((response) => {
                        this.selectedPicture.title = this.modalTextBuffer.trim();  /* Update picture caption text in the grid after the modal has been closed and contents saved */
                        return "OK"
                    }, (error) => {
                        alert(error)
                        return "Error"
                    })
                }, (error) => {
                    console.log("No token could be fetched from Auth0: " + error + ". Redirecting to login prompt");
                    this.$auth.loginWithRedirect();
                })
            },

            // Method for the upload file functionality
            handleFilesToBeUploadedChange(event) {
              this.filesToBeUploaded = Array.from(event.target.files);
              this.uploadProgress = 0;
              this.message = "";
            },
            onDragOver() {
              this.isDragging = true;
            },
            onDragLeave() {
              this.isDragging = false;
            },
            onDrop(event) {
              this.isDragging = false;
              const droppedItems = event.dataTransfer.items;

              const fileList = [];

              const traverseFileTree = (item, path = "") => {
                return new Promise((resolve) => {
                  if (item.isFile) {
                    item.file((file) => {
                      file.fullPath = path + file.name;
                      fileList.push(file);
                      resolve();
                    });
                  } else if (item.isDirectory) {
                    const dirReader = item.createReader();
                    dirReader.readEntries((entries) => {
                      const promises = entries.map((entry) =>
                        traverseFileTree(entry, path + item.name + "/")
                      );
                      Promise.all(promises).then(resolve);
                    });
                  }
                });
              };

              const processItems = async () => {
                const traversePromises = [];
                for (let i = 0; i < droppedItems.length; i++) {
                  const item = droppedItems[i].webkitGetAsEntry();
                  if (item) {
                    traversePromises.push(traverseFileTree(item));
                  }
                }
                await Promise.all(traversePromises);
                this.filesToBeUploaded = fileList;
                this.uploadProgress = 0;
                this.message = "";
              };

              processItems();
            },

            async uploadFiles(folderPath) {
              if (!this.filesToBeUploaded.length) return;
              
              if(folderPath == "/") {
                folderPath = "";
              }
              
              const token = await this.$auth.getTokenSilently();
              this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;

              let totalUploaded = 0;
              const totalSize = this.filesToBeUploaded.reduce((sum, file) => sum + file.size, 0);

              for (const file of this.filesToBeUploaded) {
                let startByte = 0;
                const fileSize = file.size;

                while (startByte < fileSize) {
                  const chunk = file.slice(startByte, startByte + this.chunkSize);
                  const endByte = Math.min(startByte + this.chunkSize, fileSize) - 1;
                  
                  const formData = new FormData();
                  formData.append("file", chunk, file.webkitRelativePath || file.name);

                  try {
                    await axios.post(this.serverUrl + "/video-streamer-server/rest/v2/upload/" + folderPath, formData, {
                      headers: {
                        "Content-Range": `bytes ${startByte}-${endByte}/${totalSize}`,
                        "Content-Type": "multipart/form-data",
                        'X-JWT-Assertion': `${token}`,
                      },
                    });

                    startByte += this.chunkSize;
                    totalUploaded += chunk.size;
                    this.uploadProgress = Math.round((startByte / totalSize) * 100);
                  } catch (error) {
                    console.error("Upload failed:", error.response.data);
                    this.message = `Upload failed for ${file.name}: ${error.response.data}`;
                    this.uploadFinished = new Date();
                    this.uploadFinished.setSeconds(this.uploadFinished.getSeconds() + 10);  // Visa upload resultat-message i max 10 sekunder
                    return;
                  }
                }
              }
              this.message = "All files uploaded successfully!";
              this.uploadFinished = new Date();
              this.uploadFinished.setSeconds(this.uploadFinished.getSeconds() + 10); // Visa upload resultat-message i max 10 sekunder
              this.filesToBeUploaded = [];
              this.uploadProgress = 0;
              this.fetchData();
            },

            createFolder(folderPath) {
              if(folderPath == "/") {
                folderPath = "";
              }
              this.$refs.modalCreateFolder.show();
            },

            onSubmitCreateFolder(event) {
              if(this.createFolderTextBuffer === null) {
                console.log("Text not changed, null");
                return;
              }
              console.log("Creating new folder: " + this.createFolderTextBuffer.trim());
              const formData = new FormData();
              formData.append("folderName", this.createFolderTextBuffer.trim());

              this.serverUrl = process.env.VUE_APP_BACK_END_HOST_URL;
                this.$auth.getTokenSilently().then((token) => {
                    axios.post(this.serverUrl + "/video-streamer-server/rest/v2/folder/" + this.fetchedFolder.path, formData,
                    {
                        headers: {
                            //Authorization: `Bearer ${this.jwtToken}`    // send the access token through the 'Authorization' header
                            //'X-JWT-Assertion': '${this.jwtToken}'
                            'X-JWT-Assertion': `${token}`
                        }
                    }).then((response) => {
                        this.createFolderTextBuffer = "";
                        this.fetchData();
                        return "OK"
                    }, (error) => {
                        alert(error)
                        return "Error"
                    })
                }, (error) => {
                    console.log("No token could be fetched from Auth0: " + error + ". Redirecting to login prompt");
                    this.$auth.loginWithRedirect();
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#breadcrumb {
    color: #ff3eff;
}
.fixed_header {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    top: 0px; /* top left corner should start at topmost spot */
    width: 100vw; /* take up the full browser width */
    z-index: 201; /* high z index so other content scrolls underneath */
    height: 25px; /* define height for content */
}

.grid-container_mobile {
    background-color: black;
    //display: grid;
    //grid-auto-flow: row;
}

.grid-container {
    //border: 1px;
    width: 100%;
    background-color: black;
    /*display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0px;
    grid-auto-flow: column;*/
    /*grid-auto-rows: minmax(100px, auto);
    grid-template-rows: repeat(auto-fill, 100px);
  grid-template-columns: repeat(auto-fill, 100px);
  grid-auto-columns: 100px;
  grid-auto-rows: 100px;*/
}

.caption {
    overflow-x: hidden;
    overflow-y: hidden;
    max-height: 120px;
    min-height: 40px;
    background: -webkit-linear-gradient(#eee, #000);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.video_mobile {
    width: 100%;
}

.video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    
}

.thumbnail_mobile {
    width: 100%;
}

.thumbnail {
    background-color: yellow;
}

.video33_mobile {
    //border: 1px solid red;
    display: block;
}

// Bilder är oftast i 4:3-format vilket blir 480 x 360 px i posterformat.
// Videor är oftast i 16:10-format vilket blir 480 x 270 px i posterformat
// Vi vill att arean för varje objekt ska vara lika stor för alla bilder
// och videor, så därför får varje poster vara max 480 x 360 px. Men sedan
// lägger vi på 60 px för eventuell bildtext också, så då blir arean 480 x 420 px.

.video33 {
    //border: 1px solid red;
    //display: block;
    float: left;
    width: 480px; height: 420px;
    margin: 10px;
    padding: 0px;
    overflow: hidden;
    //margin-left: auto;
    //margin-right: auto;
    //object-fit: cover;
}

.picture33_mobile {
    //border: 1px solid red;
    display: block;
    width: 100%;
}

.picture33 {
    //border: 1px solid red;
    //display: block;
    float: left;
    width: 480px; height: 420px;
    margin: 10px;
    padding: 0px;
    overflow: hidden;
    //margin-left: auto;
    //margin-right: auto;
    //object-fit: cover;
    text-align: center;
}

.video50 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: 100%;
}
.video100 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
}

.pswp__caption__center {
    text-align: center
}

.fixed_pagination {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    float:right;
    bottom: 0px; /* top left corner should start at topmost spot */
    right: -1px;
    width: 100vw; /* take up the full browser width */
    z-index: 203; /* high z index so other content scrolls underneath */
    height: 50px; /* define height for content */
}

.mycards {
  max-width: 3840px;
  margin: 0 auto;
  display: grid;
  grid-gap: 1rem;
}

@media (min-width: 600px) {
  .mycards { grid-template-columns: repeat(2, 1fr); }
}

@media (min-width: 900px) {
  .mycards { grid-template-columns: repeat(3, 1fr); }
}

@media (min-width: 1200px) {
  .mycards { grid-template-columns: repeat(4, 1fr); }
}

@media (min-width: 1500px) {
  .mycards { grid-template-columns: repeat(5, 1fr); }
}

@media (min-width: 1800px) {
  .mycards { grid-template-columns: repeat(6, 1fr); }
}

@media (min-width: 2100px) {
  .mycards { grid-template-columns: repeat(7, 1fr); }
}


// For the upload file functionality
.upload-container {
  gap: 10px;
}
button {
  padding: 10px;
  background-color: #42b983;
  color: white;
  border: none;
  cursor: pointer;
}
button:disabled {
  background-color: gray;
  cursor: not-allowed;
}
progress {
  width: 100%;
}

.drop-zone {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  transition: background-color 0.2s ease;
}

.drag-over {
  background-color: #e0f7fa;
}

</style>
